import axios from '@/axios.js'

export default {
    meeting({ commit, dispatch }, appointmentId)  {
        axios.post('/meetings/show', {
            appointment_id: appointmentId
        })
        .then(function (response) {
            commit('MEETING', response);
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    join({ commit, dispatch }, meetingToken) {
        axios.get('/meetings/join?token='+meetingToken)
        .then(function (response) {
            commit('JOIN', response);
            dispatch('user/loginMeeting', response, {root: true }) //put user in state
            dispatch('notification/notification', response, {root: true })
        })
        .catch(function (error) {
            dispatch('notification/notification', error.response, {root: true})
        });
    },
    sendTipToSpecialist({ commit, dispatch, state }, data) {
        axios.post('/client/payments/tip', data)
        .then(function (response) {

            dispatch('notification/notification', response, {root: true })

            if(response.status == 200 && response.data.success == true && !response.data.payment_ref) {
                commit('SEND_TIP_TO_SPECIALIST', response);
            } else {
                var dataPayment = {
                    currency: response.data.currency,
                    gateway: response.data.gateway,
                    payment_ref: response.data.payment_ref,
                    client_secret: response.data.client_secret,
                    payment_type: response.data.payment_type,
                    subtotal: response.data.subtotal,
                    vat: response.data.vat,
                    total: response.data.total,
                    entity: 'tips',
                    payload: data,
                    description: 'Alimentare cont'
                }
                dispatch('payments/updateUnfinished', dataPayment, {root: true});
                state.feedbackModal.active = false;
            }
        });
    },
    
    finish({ commit }) {
        commit('FINISH');
    },
}
